import React from 'react';
import { Avatar } from '../common/Avatar';
import { TeamBadge } from '../common/TeamBadge';
import { formatNumber, formatPercent } from '../../utils/format';
import type { BlandLoRow } from '../../utils/bland';
interface BlandLoTableProps {
  rows: BlandLoRow[];
  title: string;
  showRank?: boolean;
}
export function BlandLoTable({
  rows,
  title,
  showRank = true
}: BlandLoTableProps) {
  return <section aria-label={title} className="rounded-2xl border border-line bg-surface shadow-card" data-id="element-14" data-mp="27hp9k4fjt25q">
      <div className="flex items-baseline justify-between gap-3 px-6 pb-3 pt-5" data-id="element-15" data-mp="22k6xi568i6ti">
        <h2 className="text-base font-semibold text-ink" data-id="element-16" data-mp="2gak70byrxtky">{title}</h2>
        <p className="text-xs text-subtle" data-id="element-17" data-mp="2gcwx5ceora93">Live transfers from the Bland AI dialer</p>
      </div>
      <div className="overflow-x-auto" data-id="element-18" data-mp="2bhzf5fzfhqk2">
        <table className="w-full min-w-[760px] text-sm" data-id="element-19" data-mp="1ntzm29en9o2b">
          <thead data-id="element-20" data-mp="1nserijsby54g">
            <tr className="border-y border-line bg-canvas/60 text-xs text-muted" data-id="element-21" data-mp="1jsw7rrc8w037">
              {showRank && <th scope="col" className="py-2.5 pl-6 pr-2 text-left font-medium" data-id="element-22" data-mp="2447x7k4ypvqa">#</th>}
              <th scope="col" className={`py-2.5 pr-4 text-left font-medium ${showRank ? 'pl-2' : 'pl-6'}`} data-id="element-23" data-mp="242dm0xjhthze">Loan officer</th>
              <th scope="col" className="px-4 py-2.5 text-left font-medium" data-id="element-24" data-mp="2dub14fdmgu3e">Team</th>
              <th scope="col" className="px-4 py-2.5 text-right font-medium" data-id="element-25" data-mp="2it4d23d9gd1g">Transfers received</th>
              <th scope="col" className="px-4 py-2.5 text-right font-medium" data-id="element-26" data-mp="1l5digb5i0va4">Opportunities</th>
              <th scope="col" className="py-2.5 pl-4 pr-6 text-left font-medium" data-id="element-27" data-mp="1q4gnhvlhb1i3">Transfer → opportunity</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-28" data-mp="1v2i50c39asrg">
            {rows.map(r => <tr key={r.agent.id} data-id="element-29" data-mp="2035xz3b1pjob">
                {showRank && <td className="py-2.5 pl-6 pr-2" data-id="element-30" data-mp="200a01ez76uzv">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full border border-line text-xs font-semibold text-muted" data-id="element-31" data-mp="36hx0fbfthckg">{r.rank}</span>
                  </td>}
                <td className={`py-2.5 pr-4 ${showRank ? 'pl-2' : 'pl-6'}`} data-id="element-32" data-mp="1be8rfpfyjxr0">
                  <div className="flex items-center gap-3" data-id="element-33" data-mp="16h8ldej3yuzw">
                    <Avatar name={r.agent.name} size="sm" data-id="element-34" data-mp="16itfj31igbx8" />
                    <div className="leading-tight" data-id="element-35" data-mp="1kex8kt0nee84">
                      <p className="whitespace-nowrap font-semibold text-ink" data-id="element-36" data-mp="1gemz36dnd5oi">{r.agent.name}</p>
                      <p className="text-xs text-muted" data-id="element-37" data-mp="sp26rwvlsw2k">Ext. {r.agent.extension}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-2.5" data-id="element-38" data-mp="nr943dtiek71">
                  <TeamBadge team={r.agent.team} data-id="element-39" data-mp="11hci5hi8j7le" />
                </td>
                <td className="px-4 py-2.5 text-right text-ink" data-id="element-40" data-mp="11inljg7rqdbz">{formatNumber(r.transfers)}</td>
                <td className="px-4 py-2.5 text-right font-bold text-ink" data-id="element-41" data-mp="wpcog6srdax9">{formatNumber(r.opportunities)}</td>
                <td className="py-2.5 pl-4 pr-6" data-id="element-42" data-mp="8yyq5yjkyfu8">
                  <div className="flex items-center gap-3" data-id="element-43" data-mp="509h2i5krkge">
                    <div className="h-1.5 w-28 overflow-hidden rounded-full bg-canvas" aria-hidden data-id="element-44" data-mp="4xn7ye31cww2">
                      <div className="h-full rounded-full bg-src-bland" style={{
                    width: `${Math.min(100, r.conversion * 100)}%`
                  }} data-id="element-45" data-mp="3vrnh8fhp6dti" />
                    </div>
                    <span className="w-12 text-right font-semibold text-ink" data-id="element-46" data-mp="3h4atck4f3vzy">{formatPercent(r.conversion)}</span>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}